/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import InteractiveElement from '@dtvgo/interactive-element';

/* Components */
import QrCode from '../QrCode';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './FocusableBanner.scss';

function FocusableBanner({
  title,
  subtitle,
  link,
  fixedPhrase,
  icon,
  className,
  focused,
}) {
  return (
    <InteractiveElement
      className="dtv-html5-c-focusable-banner"
    >
      <div className={`dtv-html5-c-focusable-banner__content ${focused ? 'dtv-html5-c-focusable-banner__content--focused' : ''} ${className}`}>
        <div className="dtv-html5-c-focusable-banner__icon-content">
          {icon && <img src={icon} alt="banner icon" className="dtv-html5-c-focusable-banner__icon" />}
        </div>
        <div className="dtv-html5-c-focusable-banner__text-content">
          <h3 className="dtv-html5-c-focusable-banner__title">
            {title}
          </h3>
          <p className="dtv-html5-c-focusable-banner__subtitle">
            {subtitle}
          </p>
          <p className="dtv-html5-c-focusable-banner__fixed-phrase">
            {fixedPhrase}
          </p>
        </div>
        <div className="dtv-html5-c-focusable-banner__qr-code-content">
          { link
            && (
            <QrCode
              data={link}
              className="dtv-html5-c-focusable-banner__qr-code"
            />
            )}
        </div>
      </div>
    </InteractiveElement>
  );
}

FocusableBanner.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  link: PropTypes.string,
  fixedPhrase: PropTypes.string,
  icon: PropTypes.string,
  focused: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

FocusableBanner.defaultProps = {
  className: '',
  title: '',
  subtitle: '',
  link: '',
  fixedPhrase: '',
  icon: '',
};

export default memo(withInteractiveFocusable()(memo(FocusableBanner)));
